<template>
  <div class="mb-6">
    <label class="mp-custom-label mb-4">{{ field.label }}</label>

    <div
      class="question-container"
      :class="{
        'question-container--two-columns': field.inputValues.length <= 2,
      }"
    >
      <div
        v-for="(inputValue, index) in field.inputValues"
        :key="field.identifier + index"
        @click="toggleSelection(inputValue)"
      >
        <div
          v-if="inputValue.labelIcon"
          class="answer-tile has-text-grey-icon cursor-pointer"
          :class="{
            'answer-tile--active': selectedValues.includes(inputValue.value),
          }"
        >
          <b-icon
            icon-pack="fa"
            :icon="inputValue.labelIcon"
            type="is-grey-icon"
            size="is-medium"
            class="mb-1"
          ></b-icon>

          <br />

          <span>{{ inputValue.text }}</span>
        </div>

        <div v-else>
          <div
            class="answer-tile has-text-grey-icon cursor-pointer"
            :class="{
              'answer-tile--active': selectedValues.includes(inputValue.value),
            }"
          >
            <span>{{ inputValue.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplicationFlowCheckboxQuestion",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
    },
  },
  data() {
    return {
      selectedValues: [],
    };
  },
  mounted() {
    const selectedValues = this.$store.getters[
      "application/getFlowQuestionAnswer"
    ](this.field.identifier);

    if (selectedValues) {
      this.selectedValues = JSON.parse(selectedValues);
    } else {
      this.selectedValues = [];
    }

    this.$watch("selectedValues", this.valueWatcher);
  },
  methods: {
    valueWatcher() {
      this.$store.dispatch("application/saveDynamicData", {
        key: this.field.identifier,
        value: JSON.stringify(this.selectedValues),
      });
    },
    toggleSelection(inputValue) {
      const index = this.selectedValues.findIndex(
        (val) => val === inputValue.value
      );

      if (index > -1) {
        this.selectedValues.splice(index, 1);
      } else {
        this.selectedValues.push(inputValue.value);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/colors.scss";

$border-color: #dfe6ef;

.question-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;

  &--two-columns {
    grid-template-columns: repeat(2, 1fr);
  }

  .answer-tile {
    border: 1px solid $border-color;
    border-radius: 1rem;
    padding: 0.7rem;
    text-align: center;
    font-size: 0.75rem;
    overflow: hidden;
    word-break: break-word;
    height: 100%;
    transition: all 0.1s;

    &--active {
      border: 2px solid $blue;
      color: $blue !important;
    }

    .icon {
      font-size: 1.2rem;
      color: inherit !important;
    }
  }
}
</style>
